import type { CreateCustomerData } from '../schemas'

const INVOICE_VALUE_KEYS = [
  'firstName',
  'lastName',
  'email',
  'mobile',
  'street',
  'street2',
  'city',
  'zip',
  'country_code',
  'birth_date',
  'vatId',
] as const satisfies ReadonlyArray<keyof NonNullable<CreateCustomerData['invoice']>>

export const hasAnyInvoiceData = (
  invoice?: Partial<NonNullable<CreateCustomerData['invoice']>> | null
) => {
  if (!invoice) {
    return false
  }
  return INVOICE_VALUE_KEYS.some((key) => {
    const value = invoice[key]
    return value != null && value !== ''
  })
}

/** Detects whether the invoice form has any user-entered values (ignores `type`). */
export const hasAnyInvoiceFormValues = (values: Record<string, unknown>) =>
  INVOICE_VALUE_KEYS.some((key) => {
    const value = values[key]
    return value != null && value !== ''
  })
